/**
 * AccessDeniedPage — the page exists, this user's role doesn't reach it.
 *
 * The router registers every path in `userProfile.restrictedRoutes` here, so a
 * permission miss says so plainly instead of falling through to the catch-all
 * 404 (Trello TYTHVoW2: a case Viewer clicked "Begin Uploading Documents",
 * which targets /manage_uploaded_files — a route Viewers don't have — and got
 * "404 - Page Not Found", which reads like the app is broken).
 *
 * Deliberately says nothing about WHICH role would grant access; that's the
 * administrator's call, not information this page should hand out.
 *
 * Shares page-route-message.module.css with NotFoundPage — same shape, two
 * different meanings.
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Card } from '../design-system';
import styles from './page-route-message.module.css';

export default function AccessDeniedPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.page}>
      <Card padding="lg" className={styles.panel}>
        <div className={`${styles.iconBox} ${styles.denied}`} aria-hidden="true">
          <LockOutlinedIcon fontSize="large" />
        </div>
        <h1 className={styles.title}>You don&apos;t have access to this page</h1>
        <p className={styles.message}>
          Your role on this case doesn&apos;t include this page. If you think you
          should have access, contact your case administrator.
        </p>
        <p className={styles.path}>{location.pathname}</p>
        <button className={styles.action} type="button" onClick={() => navigate('/')}>
          Go to Dashboard
        </button>
      </Card>
    </div>
  );
}
